<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <form @submit.prevent="canEdit ? onSubmit() : null" v-if="person">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="EmailAddress">Email Address</label>
                        <input class="form-control" disabled placeholder="Email Address" v-model="person.emailAddress">
                    </div>
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="EmailAlias">Email Alias</label>
                        <input :class="{'is-invalid': $v.person.emailAlias.$invalid}" :disabled="!canEdit"
                               autocomplete="off"
                               class="form-control" maxlength="70"
                               placeholder="Email Alias" v-model="person.emailAlias">
                        <span class="invalid-feedback"
                              v-if="$v.person.emailAlias">Please enter a valid email address</span>
                    </div>
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="NetLoginId">Net login</label>
                        <input class="form-control" disabled placeholder="Net login Id" v-model="person.netLoginId">
                    </div>
                    <div class="col-md-3 col-sm-12 form-group" v-if="person.oracleId">
                        <label for="OracleUserName">Oracle Username</label>
                        <input :disabled="!canEdit" autocomplete="off" class="form-control"
                               placeholder="Oracle Username" v-model="person.oracleUserName">
                    </div>
                </div>

                <div class="row" v-if="person.oracleId">
                    <div class="col-12 form-group">
                        <AppCheckBox :disabled="!canEdit"
                                     v-model="person.networkBillingIndicator">Network Billing Indicator
                        </AppCheckBox>
                    </div>
                </div>
            </div>
            <div class="card-footer d-print-none text-right">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit" v-if="canEdit">Save</button>
                <RouterLink :disabled="isSubmitting" :to="{name:'People'}" class="btn btn-danger">Back</RouterLink>
            </div>
        </form>
    </AppLoadingContainer>
</template>

<script>
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import PersonService from "../../services/PersonService";
    import {email} from "vuelidate/lib/validators";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            AppCheckBox,
            AppLoadingContainer
        },
        data() {
            return {
                person: {},
                isSubmitting: false,
                isLoaded: false
            }
        },
        props: {
            personId: {
                type: String,
                required: true
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.NetworkAdministrator);
            }
        },
        methods: {
            onSubmit() {
                if (!this.canEdit)
                    return;

                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.isSubmitting = true;
                PersonService.updatePerson(vm.person)
                    .then(() => {
                        vm.alert(ToastType.Success, "The person was successfully updated")
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => vm.isSubmitting = false);
            }
        },
        created() {
            const vm = this;

            // Retrieve this specific organization
            PersonService.getPerson(vm.personId)
                .then(function (response) {
                    vm.person = response;
                }).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true);
        },
        validations: {
            person: {
                emailAlias: {
                    email
                }
            }
        }
    }
</script>
